import { authorizedAPI } from '@/config/axios.config';

export interface QueryMetricsRequest {
  subscriptionId: string;
  query: string;
  start?: string;
  end?: string;
  step?: string;
}

export interface QueryRangeMetricsRequest {
  subscriptionId: string;
  query: string;
  start: string;
  end: string;
  step?: string;
}

export interface MetricValue {
  metric: Record<string, string>;
  value?: [number, string];
  values?: Array<[number, string]>;
}

export interface MetricsQueryResponse {
  status: string;
  data: {
    resultType: string;
    result: MetricValue[];
  };
}

export interface MetricsQueryRangeResponse {
  status: string;
  data: {
    resultType: string;
    result: Array<{
      metric: Record<string, string>;
      values: Array<[number, string]>;
    }>;
  };
}

class MetricsService {
  /**
   * Execute instant metrics query
   */
  async queryMetrics(
    request: QueryMetricsRequest,
  ): Promise<MetricsQueryResponse> {
    const response = await authorizedAPI.post<MetricsQueryResponse>(
      '/metrics/query',
      request,
    );
    return response.data;
  }

  /**
   * Execute range metrics query
   */
  async queryRange(
    request: QueryRangeMetricsRequest,
  ): Promise<MetricsQueryRangeResponse> {
    const response = await authorizedAPI.post<MetricsQueryRangeResponse>(
      '/metrics/query-range',
      request,
    );
    return response.data;
  }
}

export const metricsService = new MetricsService();

